// TODO: this should be POST requests - we could possibly end up with caching issues GET
export default function removeSellerFromPlanService($http) {
  'ngInject';

  return function (responseId, purchasePlanId) {
    console.warn(
      'The removeSellerFromPlanService has been deprecated and will be removed from a future release.'
    );

    return $http.get(
      '/aptitude/buyer/PurchasePlanServiceController/removeSellerFromPlan',
      { params: { responseId: responseId, purchasePlanId: purchasePlanId } }
    );
  };
}
